import React from 'react';
import histogram from '../../assets/images/icon_histogram.png';
import boxplot from '../../assets/images/icon_boxplot.png';

const SegmentedControl_totalChargingTime = ({ selected, onChange = () => {} }) => {
  const segments = [
    { label: 'histogram', icon: histogram },
    { label: 'boxplot', icon: boxplot },
  ];

  const containerStyle = {
    display: 'flex',
    border: '1px solid gray',
    borderRadius: '16px',
    overflow: 'hidden',
    marginLeft: '10px',
  };

  const buttonStyle = (isSelected) => ({
    padding: '4px 12px',
    cursor: 'pointer',
    backgroundColor: isSelected ? '#CBD3DC' : '#ffffff',
    color: '#000000',
    border: 'none',
    outline: 'none',
    fontWeight: isSelected ? 'bold' : 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  const iconStyle = {
    height: '16px',
    width: '16px',
  };

  return (
    <div style={containerStyle}>
      {segments.map((segment) => (
        <button
          key={segment.label}
          style={buttonStyle(selected === segment.label)}
          onClick={() => onChange(segment.label)}
          title={segment.label}
        >
          <img src={segment.icon} alt={segment.label} style={iconStyle} />
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl_totalChargingTime;
